// extracted by mini-css-extract-plugin
export var pillTrigger = "_54-0";